import {
  compose,
  css,
  flexbox,
  FlexboxProps,
  FlexProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  space,
  SpaceProps,
} from '@wrisk/styled-system'
import { DetailedHTMLProps, ImgHTMLAttributes } from 'react'
import styled from 'styled-components'

export interface ImageProps
  extends Omit<
      DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>,
      keyof LayoutProps
    >,
    LayoutProps,
    SpaceProps,
    FlexboxProps,
    FlexProps,
    PositionProps {}

export const Image = styled.img<ImageProps>(
  css({
    display: 'inline-block',
    width: '100%',
  }),
  compose(layout, space, flexbox, position),
)
